import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Iter, Step2 } from '../../assets/models/iter.model';
import { RestTmtService } from '../rest-tmt.service';
import { Title } from '@angular/platform-browser';
import { PrintEcComponent } from './print-ec/print-ec.component';
import { PrintComponent } from './print/print.component';
import { PwaManifestService } from '../services/pwa-manifest.service';
import * as JSZip from 'jszip';

declare const mammoth: any;

/**ToDo Documentazione */
@Component({
  selector: 'app-home',
  styleUrls: ['./home.component.scss'],
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {

  public citiesImages: string[] = [];
  public days: any;
  public errorMessage = '';
  public iter: Iter | undefined;
  public menuGroups: string[][] = [];
  public menuIcons: any = {};
  public selectedId = '';
  public initialTab = 'overview';
  public isCancelledPractice = false;
  public showError = false;
  public showLoading = true;
  public steps: Step2[] = [];
  public subscription: Subscription = new Subscription();
  public urlCitiesImages = '';
  public logoAdv: string = '';
  public logoTourOperator = '';
  public selectLanguageView: boolean = true;
  /** Colore di sfondo della barra superiore (tenant `topBarColor`); assente ⇒ barra invariata. */
  public topBarColor: string = '';
  public enableAccountBalanceServicePriceDetails: boolean = true;
  public version = '';
  public serviceIcons: any = {};
  private client: any;
  public consolidator: any;
  enableItineraryViewServices: boolean = true;
  public itineraryMode: string = 'detail';
  public enableTravelStepsTab: boolean = false;
  /** Tenant `menuConfiguration.splitTransportTabs`: se `true` il tab "Trasporti" è sostituito da "Voli" + "Trasferimenti"; assente ⇒ invariato. */
  public enableSplitTransportTabs: boolean = false;
  /** Tenant `menuConfiguration.mobileInfoVisible`: assente/true ⇒ header mobile invariato; false ⇒ info nel collapse del menu. */
  public mobileInfoVisible: boolean = true;
  /** Tenant `enableFlightPassengers`: mostra i nomi passeggeri per volo (assente ⇒ invariato). */
  public enableFlightPassengers: boolean = false;
  public ignoredIsoCodes: string = '';
  /** Blacklist tipologie activity (tenant `categoryBlacklist`), solo tab Activities. */
  public categoryBlacklist: string[] = [];
  public allDays: any = {
    hotels: [],
    flights: [],
    cars: [],
    optionals: [],
    escorteds: [],
    transfers: []
  };
  public documents: any = [];
  public generalNotes: any = [];
  public countryNotes: any = [];
  public supplierNotes: any = [];

  public feedbackModalReference!: NgbModalRef;
  public feedbackForm: FormGroup;
  stars: number[] = [1, 2, 3, 4, 5];
  itineraryValue: number = 0;
  priceValue: number = 0;
  count = 5;
  @ViewChild('itinerarybutton') public itinerarybutton!: ElementRef;
  @ViewChild('pricebutton') public pricebutton!: ElementRef;
  private bookId: any;
  private pin: any;
  public isTravelAgency: boolean = false;
  public feeFlight: any = 0;
  public feeLandServices: any = 0;
  public footerText: any = '';
  public advInformations: any = {};
  showToast: boolean = false;
  messageToast: string = '';
  classToast = '';
  supportName: any;
  supportPhoto: any;
  isFlightTaxInSummaryIncluded: boolean = false;
  isFeedbackEnabled: boolean = true;
  terms: boolean = false;
  showOnlyTotalPrice: boolean = false;
  showOptionlServices: boolean = false;
  replaceShowDescriptionButtonWithNotes: boolean = false;
  showSummaryDetail: boolean = false;
  setTaxFlightFee: boolean = false;
  showGeneralNotes: boolean = false;
  showSummaryClient: boolean = true;
  hideOtherTab: boolean = false;
  hideHotelMedia: boolean = false;
  /** Tenant `enableNotesPdf`: attiva i link ai PDF nel tab Note (assente/false ⇒ invariato). */
  public enableNotesPdf: boolean = false;
  /** Tenant `generalPdf`: pdf generali configurati (etichetta per lingua); assente ⇒ nessuno. */
  public generalPdf: any[] = [];
  combinePriceServices: boolean = false;
  auditAgency: boolean = false;
  termsPath: string = '';
  termsHtml: any = null;
  termsTableBorders: any[] = [];
  termsImageSizes: any[] = [];
  public extra: any = { fees: [], insurances: [] };
  public limitMarkup: any = 0;
  public insuranceSummaryVisible: boolean = true;
  public lastUpdate: string = '';
  public pdfs: any = [];
  favIcon: any = document.querySelector('#appIcon');
  noImageUrl: any;
  public defaultImages: any = {};
  public state: string = '';
  public showPrintButton = false;
  public printEcEnabled = false;
  imageFee: any;
  imageInsurance: any;

  constructor(
    public readonly service: RestTmtService,
    public readonly activatedRoute: ActivatedRoute,
    public readonly translateService: TranslateService,
    private readonly modalService: NgbModal,
    private readonly formBuilder: FormBuilder,
    private titleService: Title,
    private http: HttpClient,
    private readonly pwaManifestService: PwaManifestService
  ) {
    this.feedbackForm = this.formBuilder.group({
      emailFrom: [''],
      itinerary: [''],
      price: [''],
      message: ['']
    });
  }

  changeIcon(url: string) {
    this.favIcon.href = url;
  }

  /**
   * Il raggruppamento del menu e le icone sono attivi solo se il tenant
   * configura `menuConfiguration`: chiave assente ⇒ menu invariato (multi-tenant additivo).
   */
  public get menuIconsEnabled(): boolean {
    return !!this.menuIcons && Object.keys(this.menuIcons).length > 0;
  }

  /** Path dell'icona custom per la voce di menu (id voce stabile, non label). */
  public getMenuIcon(voice: string): string | undefined {
    return this.menuIcons ? this.menuIcons[voice] : undefined;
  }

  /**
   * true quando `voice` è la prima voce di un gruppo di menu successivo al primo:
   * quel punto è dove va inserito il separatore (gruppi configurati via `menuConfiguration.groups`).
   */
  public menuGroupStart(voice: string): boolean {
    return this.menuGroups.some((group, index) => index > 0 && group[0] === voice);
  }

  /**
   * Gate dei link PDF nel tab Note: attivo solo con `enableNotesPdf === true`;
   * assente/false ⇒ tab invariato (`generalPdf` è solo la lista, non attiva).
   */
  public get notesPdfEnabled(): boolean {
    return this.enableNotesPdf;
  }

  /** Tenant `altriServizi`: personalizzazione tab "Altri servizi" (assente ⇒ invariato). */
  public get altriServizi(): any {
    return this.client?.altriServizi;
  }

  /** true quando la config tenant `altriServizi` attiva la personalizzazione. */
  public get altriServiziActive(): boolean {
    const config = this.altriServizi;
    if (config === true) {
      return true;
    }
    if (config && typeof config === 'object') {
      return config.enabled !== false;
    }

    return false;
  }

  /** Config `deflusso` del tab "Altri servizi" (tenant); assente ⇒ indefinita. */
  public get altriServiziDeflusso(): any {
    return this.altriServizi?.deflusso;
  }

  /** Icona custom del tab "Altri servizi", valorizzata solo a personalizzazione attiva. */
  public get altriServiziIcon(): string | undefined {
    return this.altriServiziActive ? this.altriServizi?.icon : undefined;
  }

  /**
   * Gate del tab "Altri servizi": con personalizzazione assente è identico a oggi;
   * quando attiva considera anche le activity defluite dal parametro `deflusso`.
   */
  public get showExtraTab(): boolean {
    if (this.isCancelledPractice || this.hideOtherTab) {
      return false;
    }
    const hasFeeOrInsurance = (this.extra?.fees?.length || 0) > 0 ||
      (this.extra?.insurances?.length || 0) > 0;

    return hasFeeOrInsurance || this.hasDeflusedActivities();
  }

  public ngOnInit(): void {
    const script = document.createElement('script');
    script.src = 'assets/js/mammoth.browser.min.js';
    script.onload = () => console.log('Mammoth loaded!');
    document.head.appendChild(script);

    this.citiesImages = [];
    this.client = this.service.getClient();
    const menuConfiguration = this.client.menuConfiguration || {};
    this.serviceIcons = this.client.serviceIcons || {};
    this.menuIcons = menuConfiguration.icons || {};
    this.menuGroups = menuConfiguration.groups || [];
    this.service.loadStyleTenant();
    this.consolidator = this.client.consolidator;
    this.changeIcon(`assets/custom/${this.client.consolidator}/images/favicon.ico`);
    this.logoTourOperator = `assets/custom/${this.client.consolidator}/images/logo_tour_operator.png`;
    this.selectLanguageView = this.client.selectLanguageView;
    this.topBarColor = this.client.topBarColor || '';
    this.enableItineraryViewServices = this.client.enableItineraryViewServices;
    this.itineraryMode = this.client.itineraryMode || 'detail';
    this.enableTravelStepsTab = this.client.enableTravelStepsTab || false;
    this.enableSplitTransportTabs = menuConfiguration.splitTransportTabs === true;
    this.mobileInfoVisible = menuConfiguration.mobileInfoVisible !== false;
    this.enableFlightPassengers = this.client.enableFlightPassengers === true;
    this.ignoredIsoCodes = this.client.ignoredIsoCodes || '';
    this.categoryBlacklist = this.client.categoryBlacklist || [];
    if (this.altriServiziActive) {
      this.loadAltriServiziStyles(this.altriServizi?.css);
    }
    this.enableAccountBalanceServicePriceDetails = this.client.enableAccountBalanceServicePriceDetails;
    this.isFlightTaxInSummaryIncluded = this.client.isFlightTaxInSummaryIncluded;
    this.isFeedbackEnabled = this.client.isFeedbackEnabled;
    this.supportName = this.client.supportName;
    this.supportPhoto = this.client.supportPhoto;
    this.terms = this.client.terms.isActiveTab;
    this.termsPath = this.client.terms.fileName;
    this.limitMarkup = this.client.limitMarkup;
    this.insuranceSummaryVisible = this.client.insuranceSummaryVisible;
    this.showOnlyTotalPrice = this.client.showOnlyTotalPrice;
    this.showOptionlServices = this.client.showOptionlServices;
    this.replaceShowDescriptionButtonWithNotes = this.client.replaceShowDescriptionButtonWithNotes === true;
    this.showSummaryDetail = this.client.showSummaryDetail;
    this.setTaxFlightFee = this.client.setTaxFlightFee;
    this.showGeneralNotes = this.client.showGeneralNotes;
    this.showSummaryClient = this.client.showSummaryClient;
    this.hideOtherTab = this.client.hideOtherTab;
    this.hideHotelMedia = this.client.hideHotelMedia === true;
    this.enableNotesPdf = this.client.enableNotesPdf === true;
    this.generalPdf = this.client.generalPdf || [];
    this.combinePriceServices = this.client.combinePriceServices;
    this.auditAgency = this.client.audit_agency || false;
    this.noImageUrl = this.client.noImageUrl;
    // Fallback immagini: la generica CUSTOM del cliente (noImageUrl) vince sull'asset
    // generico di piattaforma; l'asset tipizzato resta solo quando manca anche noImageUrl.
    this.imageFee = this.client.imageFee || this.client.noImageUrl || 'assets/images/no-image-fee.jpg';
    this.imageInsurance = this.client.imageInsurance || this.client.noImageUrl || 'assets/images/no-image-insurance.jpg';
    this.defaultImages = this.buildDefaultImages(this.client.defaultImages);

    this.version = this.client.consolidator;
    this.pdfs = this.client.pdf;
    this.showPrintButton = this.client.printSettings?.showPrintButton;
    this.printEcEnabled = this.client.printSettings?.printEcEnabled === true;
    sessionStorage.setItem('version', this.version);
    this.urlCitiesImages = this.client.photoEndPoint;
    this.activatedRoute.params.subscribe((params) => {
      // Aggiorna il manifest PWA per puntare a questo itinerario specifico
      this.pwaManifestService.serveDynamicManifest();

      const bookID = params?.bookID as string;
      const pin = params?.pin as number;

      this.bookId = bookID;
      this.pin = pin;
      if (bookID) {
        if (bookID === 'test') {
          this.advInformations = {
            isTravelAgency: false,
            feeFlight: 100,
            feeLandServices: 200,
            footerText: ''
          }
          this.getDataFake();
        } else {
          this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
            this.getData(bookID, event.lang === 'nl' ? 'en' : event.lang);
            // this.getData(bookID, event.lang);
          });
          this.loadAdvInformations(pin, bookID);
        }
      }
    });

    if (this.terms) {
      setTimeout(async () => {
        let file = await this.getFile(this.client.consolidator, this.termsPath);
        await this.loadMammoth(file);
      }, 1000);
    }
  }

  public getDataFake(): void {
    this.urlCitiesImages = 'assets/images/demo/';
    this.subscription = this.service.getIterFake().subscribe(
      response => {
        this.iter = response;
        this.titleService.setTitle(this.iter.name + ' - ' + this.bookId);
        this.steps = this.iter.steps;
        this.days = this.iter?.days;
        this.state = 'Preventivo';
        this.removeDuplicatesDays();
        if ('documents' in this.iter) {
          this.documents = this.iter?.documents;
        }
        this.logoAdv = this.iter.agency?.logo
        this.aggregateAllDays();
        this.getCitiesImages();
        this.showLoading = false;
      },
      (error: {}) => {
        console.log(error);
      }
    );
  }

  public getData(bookID: string, lang: string): void {
    this.service.getIter(bookID, lang).subscribe(
      response => {
        this.iter = response;
        this.state = this.iter.state;
        // this.titleService.setTitle(this.iter.name + ' - ' + this.bookId);
        this.titleService.setTitle(this.iter.name);
        this.steps = this.iter.steps;
        sessionStorage.setItem('state', this.iter.state);
        this.logoAdv = this.iter.agency?.logo;
        this.lastUpdate = this.iter.quotation_date_last;
        if ('documents' in this.iter) {
          this.documents = this.iter?.documents;
        }

        if ('generalNotes' in this.iter) { this.generalNotes = this.iter?.generalNotes; }
        if ('countryNotes' in this.iter) { this.countryNotes = this.iter?.countryNotes; }
        if ('supplierNotes' in this.iter) { this.supplierNotes = this.iter?.supplierNotes; }

        this.extra = this.iter.extra;

        if (this.iter.days.length === 0) {
          this.isCancelledPractice = true;
          this.days = [];
          this.allDays = {
            hotels: [],
            flights: [],
            cars: [],
            optionals: [],
            escorteds: [],
            transfers: [],
            optionalsSuggested: [],
            transfersSuggested: [],
            extra: this.extra
          };
        } else {
          this.days = this.iter?.days;
          this.removeDuplicatesDays();
          this.aggregateAllDays();
          this.getCitiesImages();
        }
        this.initialTab = this.shouldOpenAccountBalance() ? 'summary' : 'overview';
        this.showLoading = false;
      },
      (error: {}) => {
        console.log(error);
      }
    );
  }

  public getCitiesImages(): void {
    if (!this.iter) {
      return;
    }

    const ignoredCodes = this.ignoredIsoCodes
      ? this.ignoredIsoCodes.split(',')
      : [];

    for (const day of this.iter?.days) {
      if (!day.city_photo) {
        continue;
      }

      if (ignoredCodes.length > 0 && ignoredCodes.includes(day.city_code ?? '')) {
        continue;
      }

      this.citiesImages.push(day.city_photo);
    }
  }

  public scrollToTop() {
    window.scrollTo(0, 0);
    document.getElementsByClassName('navbar-principale')[0].classList.remove('show');
  }

  public onItineraryNavigate(payload: { code?: string; tab: string } | string): void {
    // Back-compat: un payload stringa è il solo tab id (comportamento storico).
    const navigation = typeof payload === 'string' ? { code: undefined, tab: payload } : payload;
    const anchorId = navigation.code ? `svc-${navigation.code}` : undefined;
    this.initialTab = navigation.tab;

    // Il contenuto del tab viene reso al giro di change detection successivo:
    // si attende il frame per ancorare l'elemento, con fallback allo scroll in cima.
    requestAnimationFrame(() => {
      this.scrollToServiceAnchor(anchorId);
    });
  }

  private scrollToServiceAnchor(anchorId?: string): void {
    setTimeout(() => {
      const element = anchorId ? document.getElementById(anchorId) : undefined;
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        this.scrollToTop();
      }
    }, 0);
  }

  async loadMammoth(file: File) {
    const arrayBuffer = await file.arrayBuffer();
    const result = await mammoth.convertToHtml({ arrayBuffer });
    this.termsHtml = result.value;
    try {
      const layout = await this.readDocxLayout(arrayBuffer);
      this.termsTableBorders = layout.tables;
      this.termsImageSizes = layout.images;
    } catch (error) {
      this.termsTableBorders = [];
      this.termsImageSizes = [];
    }
  }

  private async readDocxLayout(arrayBuffer: ArrayBuffer): Promise<{ tables: any[], images: any[] }> {
    const zip = await JSZip.loadAsync(arrayBuffer);
    const documentFile = zip.file('word/document.xml');
    if (!documentFile) {
      return { tables: [], images: [] };
    }

    const documentXml = await documentFile.async('text');
    const tableBorders: any[] = [];
    const tableBlocks = documentXml.match(/<w:tbl\b[\s\S]*?<\/w:tbl>/g) || [];
    const readAttribute = (xml: string, attribute: string): string | null => {
      const match = xml.match(new RegExp(`(?:w:)?${attribute}="([^"]*)"`));
      return match ? match[1] : null;
    };

    const twipsToPixels = (twips: string | null): string | null => {
      const value = Number(twips || '0');
      return value > 0 ? `${(value / 15).toFixed(2)}px` : null;
    };

    tableBlocks.forEach(tableBlock => {
      const borderData: any = {};
      const borderBlockMatch = tableBlock.match(/<w:tblBorders\b[\s\S]*?<\/w:tblBorders>/);
      const borderBlock = borderBlockMatch ? borderBlockMatch[0] : '';
      ['top', 'right', 'bottom', 'left', 'insideH', 'insideV'].forEach(side => {
        const borderMatch = borderBlock.match(new RegExp(`<w:${side}\\b[^>]*>`));
        if (!borderMatch) {
          return;
        }

        const border = borderMatch[0];
        const value = readAttribute(border, 'val');
        const size = readAttribute(border, 'sz');
        const color = readAttribute(border, 'color');
        const cssStyle = value === 'single' ? 'solid' : value;
        const cssValue = value === 'none' || value === 'nil'
          ? 'none'
          : value && color && color !== 'auto'
            ? `${(Number(size || '0') / 8).toFixed(3)}pt ${cssStyle} #${color}`
            : null;
        if (cssValue) {
          borderData[side] = cssValue;
        }
      });

      const tableWidthMatch = tableBlock.match(/<w:tblW\b[^>]*>/);
      const tableWidth = tableWidthMatch ? tableWidthMatch[0] : '';
      const widthType = readAttribute(tableWidth, 'type');
      const explicitWidth = widthType === 'dxa' ? twipsToPixels(readAttribute(tableWidth, 'w')) : null;
      const gridWidths = tableBlock.match(/<w:gridCol\b[^>]*>/g) || [];
      const gridWidth = twipsToPixels(gridWidths.reduce((sum, gridCol) =>
        sum + Number(readAttribute(gridCol, 'w') || '0'), 0).toString());
      if (explicitWidth || gridWidth) {
        borderData.width = explicitWidth || gridWidth;
      }

      const cellMarginBlockMatch = tableBlock.match(/<w:(?:tblCellMar|tcMar)\b[\s\S]*?<\/w:(?:tblCellMar|tcMar)>/);
      if (cellMarginBlockMatch) {
        const cellMargins: any = {};
        ['top', 'right', 'bottom', 'left'].forEach(side => {
          const marginMatch = cellMarginBlockMatch[0].match(new RegExp(`<w:${side}\\b[^>]*>`));
          const margin = marginMatch ? twipsToPixels(readAttribute(marginMatch[0], 'w')) : null;
          if (margin) {
            cellMargins[side] = margin;
          }
        });
        if (Object.keys(cellMargins).length > 0) {
          borderData.cellMargins = cellMargins;
        }
      }
      tableBorders.push(borderData);
    });

    const images = (documentXml.match(/<wp:extent\b[^>]*>/g) || []).map(extent => {
      const width = Number(readAttribute(extent, 'cx') || '0');
      const height = Number(readAttribute(extent, 'cy') || '0');
      return {
        width: width > 0 ? `${(width / 9525).toFixed(2)}px` : null,
        height: height > 0 ? `${(height / 9525).toFixed(2)}px` : null
      };
    });

    return { tables: tableBorders, images };
  }

  getFile(consolidator: string, path: string): Promise<File> {
    return this.http.get(`assets/custom/${consolidator}/file/${path}`, { responseType: 'arraybuffer' })
      .toPromise()
      .then(response => new File([response], path));
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    this.loadMammoth(file);
  }

  removeDuplicatesDays() {
    const sequenceNumbers: any = {};

    // Filtriamo l'array di oggetti eliminando quelli con lo stesso sequenceNumber
    const filteredDays = this.days.map((day: any) => ({
      ...day,
      optionals: day.optionals.filter((optionals: any) => {
        if (sequenceNumbers[optionals.sequenceNumber]) {
          return false;
        } else {
          sequenceNumbers[optionals.sequenceNumber] = true;
          return true;
        }
      }),
      transfers: day.transfers.filter((transfers: any) => {
        if (sequenceNumbers[transfers.sequenceNumber]) {
          return false;
        } else {
          sequenceNumbers[transfers.sequenceNumber] = true;
          return true;
        }
      }),
      hotels: day.hotels.filter((hotel: any) => {
        if (sequenceNumbers[hotel.sequenceNumber]) {
          return false;
        } else {
          sequenceNumbers[hotel.sequenceNumber] = true;
          return true;
        }
      }),
      escorteds: day.escorteds.filter((escorted: any) => {
        if (sequenceNumbers[escorted.sequenceNumber]) {
          return false;
        } else {
          sequenceNumbers[escorted.sequenceNumber] = true;
          return true;
        }
      }),
      cars: day.cars.filter((car: any) => {
        if (sequenceNumbers[car.sequenceNumber]) {
          return false;
        } else {
          sequenceNumbers[car.sequenceNumber] = true;
          return true;
        }
      }),
    }));

    console.log('filteredDays');
    console.log(filteredDays);
    this.days = filteredDays;

  }

  aggregateAllDays() {
    this.allDays = this.days.reduce((acc: any, day: any) => {
      if (day.hotels.length > 0) { acc.hotels.push(...day.hotels); }
      if (day.flights.length > 0) { acc.flights.push(...day.flights); }
      if (day.cars.length > 0) { acc.cars.push(...day.cars); }
      if (day.optionals.length > 0) { acc.optionals.push(...day.optionals); }
      if (day.escorteds.length > 0) { acc.escorteds.push(...day.escorteds); }
      if (day.transfers.length > 0) { acc.transfers.push(...day.transfers); }
      if ('optionalsSuggested' in day) { acc.optionalsSuggested.push(...day.optionalsSuggested); }
      if ('transfersSuggested' in day) { acc.transfersSuggested.push(...day.transfersSuggested); }
      return acc;
      // tslint:disable-next-line:max-line-length
    }, { hotels: [], flights: [], cars: [], optionals: [], escorteds: [], transfers: [], optionalsSuggested: [], transfersSuggested: [], extra: [] });

    // this.allDays.flights = this.removeDuplicates(this.allDays.flights);
    this.allDays.hotels = this.removeDuplicates(this.allDays.hotels);
    this.allDays.cars = this.removeDuplicates(this.allDays.cars);
    this.allDays.transfers = this.removeDuplicates(this.allDays.transfers);
    this.allDays.optionals = this.removeDuplicates(this.allDays.optionals);
    this.allDays.escorteds = this.removeDuplicates(this.allDays.escorteds);
    this.allDays.optionalsSuggested = this.removeDuplicates(this.allDays.optionalsSuggested);
    this.allDays.transfersSuggested = this.removeDuplicates(this.allDays.transfersSuggested);
    this.allDays.extra = this.extra;
    console.log(this.allDays);
  }

  private buildDefaultImages(tenantDefaults: any): any {
    const defaults = tenantDefaults || {};
    // Precedenza: default tipizzato del tenant -> immagine generica custom del cliente
    // (noImageUrl) -> asset generico di piattaforma (solo se manca anche noImageUrl).
    const generic = this.client?.noImageUrl;
    return {
      hotel: this.resolveDefaultImage(defaults.hotel, 'assets/images/no-image-hotel.jpg', generic),
      auto: this.resolveDefaultImage(defaults.auto, 'assets/images/no-image-vehicle.jpg', generic),
      activity: this.resolveDefaultImage(defaults.activity, 'assets/images/no-image-optional.jpg', generic),
      transfer: this.resolveDefaultImage(defaults.transfer, 'assets/images/no-image-transfer.jpg', generic),
      escorted: this.resolveDefaultImage(defaults.escorted, 'assets/images/no-image-escorted.jpg', generic)
    };
  }

  private resolveDefaultImage(tenantDefault: any, asset: string, generic?: string): string {
    return tenantDefault || generic || asset;
  }

  private shouldOpenAccountBalance(): boolean {
    if (this.isCancelledState() || this.days?.length === 0) {
      return true;
    }

    const hasFeeOrInsurance = (this.extra?.fees?.length || 0) > 0 ||
      (this.extra?.insurances?.length || 0) > 0;
    const hasItineraryServices = Object.keys(this.allDays)
      .filter(key => key !== 'extra')
      .some(key => this.allDays[key]?.length > 0);

    return hasFeeOrInsurance && !hasItineraryServices;
  }

  private isCancelledState(): boolean {
    const normalizedState = (this.state || '').toLowerCase();
    return normalizedState.includes('annull') || normalizedState.includes('cancel');
  }

  /** true quando ci sono activity delle categorie defluite (parametro `deflusso`). */
  private hasDeflusedActivities(): boolean {
    const categories: string[] = this.altriServiziActive
      ? (this.altriServiziDeflusso?.activityCategories || [])
      : [];
    if (categories.length === 0) {
      return false;
    }

    return (this.allDays?.optionals || []).some((group: any) =>
      (group?.optionals || []).some((optional: any) => categories.includes(optional?.category)));
  }

  /** Carica il foglio di stile dedicato al tab "Altri servizi" (una sola volta). */
  private loadAltriServiziStyles(cssUrl: string): void {
    if (!cssUrl) {
      return;
    }
    if (document.querySelector(`link[data-altri-servizi="${cssUrl}"]`)) {
      return;
    }
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = cssUrl;
    link.setAttribute('data-altri-servizi', cssUrl);
    document.head.appendChild(link);
  }

  removeDuplicates(items: any[]) {
    return items.reduce((acc, item) => {
      if (!acc.some((el: any) => el.sequenceNumber === item.sequenceNumber)) {
        acc.push(item);
      }
      return acc;
    }, []);
  }

  public open(feedbackModal: any) {
    this.feedbackModalReference = this.modalService.open(feedbackModal);
  }

  countStar(star: any, vote: boolean) {
    if (vote) {
      this.priceValue = star;
    } else {
      this.itineraryValue = star;
    }
    console.log('Value of star', star);
  }

  public feedback(): void {
    this.feedbackModalReference.close();

    const email = this.feedbackForm.value.emailFrom as string;
    const itinerary = this.feedbackForm.value.itinerary as string;
    const price = this.feedbackForm.value.price as string;
    const message = this.feedbackForm.value.message as string;

    this.service.postFeedback(email, itinerary, price, message, this.bookId).subscribe((response: any) => {
      console.log(response);
      this.feedbackForm.reset();
      this.showToast = true;

      if (response.action_result === "success") {
        this.translateService.get('SUMMARY.UPDATE-SUCCESS').subscribe((res: string) => {
          this.messageToast = res;
        });
        this.classToast = 'bg-success text-light';
      } else {
        this.translateService.get('SUMMARY.UPDATE-FAILURE').subscribe((res: string) => {
          this.messageToast = res;
        });
        this.classToast = 'bg-danger text-light';
      }
      setTimeout(() => {
        this.showToast = false;
      }, 5000);
    }, (error: HttpErrorResponse) => {
      console.log(error.error);
      this.showToast = true;
      this.translateService.get('SUMMARY.UPDATE-FAILURE').subscribe((res: string) => {
        this.messageToast = res;
      });
      this.classToast = 'bg-danger text-light';

      setTimeout(() => {
        this.showToast = false;
      }, 5000);
    });
  }

  getAdvInformations(ev: any) {
    this.service.setCustomerOutputAdvInformations(this.pin, this.bookId, ev.feeFlight, ev.feeFlightTaxes, ev.feeLandServices, ev.footerText, ev.hidePriceB2C).subscribe((data: any) => {
      this.showToast = true;
      if (data.success) {
        this.loadAdvInformations(this.pin, this.bookId);
        this.translateService.get('SUMMARY.UPDATE-SUCCESS').subscribe((res: string) => {
          this.messageToast = res;
        });
        this.classToast = 'bg-success text-light';
      } else {
        this.translateService.get('SUMMARY.UPDATE-FAILURE').subscribe((res: string) => {
          this.messageToast = res;
        });
        this.classToast = 'bg-danger text-light';
      }
      setTimeout(() => {
        this.showToast = false;
      }, 5000);
    });
  }

  public loadAdvInformations(pin: any, bookID: any) {
    this.service.getCustomerOutputAdvInformations(pin, bookID).subscribe(async (data) => {
      let history: any = await this.getAdvHistoryInformations() || [];

      this.isTravelAgency = data.isTravelAgency;
      this.advInformations = {
        isTravelAgency: this.isTravelAgency,
        feeFlight: data.feeFlight || 0,
        feeLandServices: data.feeLandServices || 0,
        footerText: data.footerText || '',
        history: history.history,
        hidePriceB2C: data.hidePriceB2C || false
      }
    });
  }

  async getAdvHistoryInformations() {
    return await this.service.getCustomerOutputAdvInformationsHistory(this.pin, this.bookId);
  }

  public openPrintModal(): void {
    // Accesso agenzia + flag tenant `printSettings.printEcEnabled`: stampa dedicata dell'Estratto
    // conto. B2C o flag off: stampa itinerario invariata.
    const printEc = this.isTravelAgency && this.printEcEnabled;
    const printComponent = printEc ? PrintEcComponent : PrintComponent;
    const modalRef = this.modalService.open(printComponent, {
      backdrop: 'static',
      centered: true,
      keyboard: false,
      scrollable: true,
      size: 'xl',
      windowClass: 'print-modal'
    });

    modalRef.componentInstance.data = {
      bookId: this.bookId,
      iter: this.iter,
      days: this.days,
      citiesImages: this.citiesImages,
      urlCitiesImages: this.urlCitiesImages,
      allDays: this.allDays,
      extra: this.extra,
      logoAdv: this.logoAdv,
      logoTourOperator: this.logoTourOperator,
      consolidator: this.consolidator,
      lastUpdate: this.lastUpdate,
      footerText: this.footerText,
      tenant: this.client, // Passa l'intero oggetto tenant
      noImageUrl: this.client.noImageUrl,
      amountApis: this.iter?.financialSummary,
      advInformations: this.advInformations
    };

    modalRef.result.then(
      (result: any) => {
        console.log('Modale chiusa con risultato:', result);
      },
      (reason: any) => {
        console.log('Modale chiusa con motivo:', reason);
      }
    );
  }

  public getTotalPax(): number {
    if (!this.iter?.rooms) {
      return 0;
    }
    let total = 0;
    for (const room of this.iter.rooms) {
      total += (room.adults || 0);
      if (room.childrenBirthdate) {
        total += room.childrenBirthdate.length;
      }
    }
    return total;
  }
}
